module.exports = __webpack_public_path__ + "img/la_logo.png?e8a494598e87e093ca5918675d16cee6";